export class AirlineMenuConfig {
  public defaults: any = {
    header: {
      self: {},
      items: [
        {
          title: $localize`:@@global.search:Search`,
          root: true,
          alignment: 'left',
          toggle: 'click',
          page: '/airline/search/airline-search',
        },
        {
          title: $localize`:@@global.quotes:Quotes`,
          root: true,
          alignment: 'left',
          toggle: 'click',
          page: '/airline/quote/quote-list',
        },
        {
          title: $localize`:@@global.flights:Flights`,
          root: true,
          alignment: 'left',
          toggle: 'click',
          page: '/airline/flight/flight-view',
        },
        {
          title: $localize`:@@global.shipments:Shipments`,
          root: true,
          alignment: 'left',
          toggle: 'click',
          submenu: [
            {
              title: $localize`:@@global.history:History`,
              page: '/airline/shipment/history-list',
            },
            {
              title: $localize`:@@global.quality:Quality`,
              page: '/airline/shipment/quality-rating-list',
            },
          ],
        },
        {
          title: $localize`:@@global.rates:Rates`,
          root: true,
          alignment: 'left',
          toggle: 'click',
          submenu: [
            {
              title: $localize`:@@global.market-rate:Market Rate`,
              page: '/airline/rate/market-rate',
            },
            {
              title: $localize`:@@global.promo-rate:Promo Rate`,
              page: '/airline/rate/promo-rate',
            },
            {
              title: $localize`:@@global.contract-rate-sheet:Contract Rate Sheets`,
              page: '/airline/rate/rate-sheet',
            },
            {
              title: $localize`:@@global.interline-rate:Interline Rate`,
              page: '/airline/rate/interline-rate',
            },
            {
              title: $localize`:@@global.spa-rate:SPA Rate`,
              page: '/airline/rate/spa-rate',
            },
            {
              title: $localize`:@@global.tct-rate:TACT Rate`,
              page: '/airline/rate/tact-rate',
            },
          ],
          subPages: ['/airline/contract-rate'],
        },
        {
          title: $localize`:@@global.promote:Promote`,
          root: true,
          alignment: 'left',
          toggle: 'click',
          page: '/airline/promote',
        },
        {
          title: $localize`:@@global.dashboards:Dashboards`,
          root: true,
          alignment: 'left',
          page: '/dashboard',
          toggle: 'click',
          submenu: [
            {
              title: $localize`:@@global.customer-details:Customer details`,
              page: '/airline/dashboard/customerDetails',
            },
            {
              title: $localize`:@@global.market-analysis:Market analysis`,
              page: '/airline/dashboard/market-analysis',
            },
            {
              title: $localize`:@@global.load-board:Load board`,
              page: '/airline/dashboard/load-board',
            },
          ],
        },
      ],
      loggedOff: {
        items: [
          {
            title: $localize`:@@global.login:Login`,
            root: true,
            alignment: 'left',
            toggle: 'click',
            page: '/auth/login',
          },
        ],
      },
    },
    aside: {
      self: {},
      items: [],
    },
  };

  public get menuItems(): any {
    return this.defaults;
  }
}
